import React, { useState } from 'react';
import api from '../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    try {
      const res = await api.post('/auth/login', { email, senha });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('admin', JSON.stringify(res.data.admin));
      window.location.href = '/dashboard';
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.icon}>⚙️</div>
          <h1 style={styles.title}>Painel de Controle</h1>
          <p style={styles.sub}>Assistente de Contas Eleitorais®</p>
          <span style={styles.badge}>Administrador</span>
        </div>
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>E-mail institucional</label>
            <input style={styles.input} type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="nome@assistenteeleitoral.com.br" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Senha</label>
            <input style={styles.input} type="password" value={senha}
              onChange={e => setSenha(e.target.value)}
              placeholder="••••••••" required />
          </div>
          {erro && <div style={styles.erro}>{erro}</div>}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar no painel'}
          </button>
        </form>
        <p style={styles.footer}>Protegido por LGPD · Sessão expira em 8 horas</p>
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight:'100vh', background:'#f0f2f5', display:'flex', alignItems:'center', justifyContent:'center' },
  card: { background:'#fff', borderRadius:16, padding:'40px 36px', width:380, boxShadow:'0 4px 24px rgba(0,0,0,0.08)' },
  header: { textAlign:'center', marginBottom:28 },
  icon: { fontSize:40, marginBottom:8 },
  title: { fontSize:20, fontWeight:600, color:'#1a1a2e', margin:'0 0 4px' },
  sub: { fontSize:13, color:'#888', margin:'0 0 10px' },
  badge: { background:'#EEEDFE', color:'#3C3489', fontSize:11, padding:'3px 12px', borderRadius:20, fontWeight:500 },
  form: { display:'flex', flexDirection:'column', gap:16 },
  field: { display:'flex', flexDirection:'column', gap:6 },
  label: { fontSize:13, color:'#555', fontWeight:500 },
  input: { padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, outline:'none' },
  erro: { background:'#fff0f0', color:'#c0392b', padding:'10px 14px', borderRadius:8, fontSize:13 },
  btn: { background:'#534AB7', color:'#fff', border:'none', borderRadius:8, padding:'12px', fontSize:15, fontWeight:600, cursor:'pointer' },
  footer: { textAlign:'center', fontSize:11, color:'#aaa', marginTop:20 }
};
